import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		try {
			// Smooth scroll
			window.scroll({ top: 0, left: 0, behavior: "smooth" });
		} catch (e) {
			// Default if browser doesn't support smooth scroll
			window.scrollTo(0, 0);
		}
	}, [pathname]);

	return null;
};

export default ScrollToTop;
